const dailyFeedingCalculatorLanding = {};

(function (dailyFeedingCalculatorLandingApp) {

    function formIsValid() {
        let isValid = true;

        if ($('#pet-type-select :selected').val() === "") {
            $("#pet-type-select-validation").css("display", "block");
            isValid = false;
        }

        return isValid;
    }

    $(document).ready(function () {

        $(document).on("click", ".js-submit", function (e) {
            e.preventDefault();
            
            if (formIsValid()) {
                const detailPageUrl = $("#feeding-calculator").data("detailpageurl");
                const petType = $('#pet-type-select :selected').val();
                window.location.href = `${detailPageUrl}?pettype=${petType}`;
            }
        });
    });

})(dailyFeedingCalculatorLanding);
